// Shared base definitions to reduce duplication
const baseTypography = {
  fontFamily: {
    primary: "'SF Pro Text', 'Work Sans', sans-serif",
    system: "'SF Pro Text', -apple-system, system-ui, BlinkMacSystemFont, sans-serif",
  },
  fontSize: {
    xsmall: '12px',
    small: '14px',
    medium: '16px',
    large: '18px',
    xlarge: '20px',
    xmlarge: '26px',
    xxlarge: '28px',
    xxxlarge: '32px',
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 590,
    bold: 600,
  },
} as const;

const baseSpacing = {
  xs: '8px',
  sm: '10px',
  md: '14px',
  lg: '11px',
} as const;

const baseBorderRadius = {
  small: '4px',
  large: '100px',
} as const;

const sharedColorCore = {
  logo: '#13377E',
  background: { mobile: '#f5f5f5', desktop: '#dcdce3' },
  notice: { bannerBg: '#f7d047', text: '#1f2937' },
  text: { primary: '#141414', secondary: '#474747', tertiary: '#1c1b1f', disabled: '#bdbdbd' },
  border: '#949494',
  footer: '#757575',
  link: '#215ECD',
  white: '#ffffff',
  baseline: '#DBDBDB',
  sectionLine: '#E0E0E0',
  inactiveBorder: '#DBDBDB',
  eyeIcon: '#4C00FF',
  documentBorder: '#22222233',
  successBg: '#23C343',
  successText: '#053D00',
} as const;

export const coldwellBankerTheme = {
  colors: {
    ...sharedColorCore,
    primary: '#1756ff',
    secondary: '#1b3c55',
    header: '#012169',
    ring: '#1756FF',
    black: '#000000',
  },
  typography: baseTypography,
  spacing: baseSpacing,
  borderRadius: baseBorderRadius,
};

export const sothebysTheme = {
  colors: {
    ...sharedColorCore,
    primary: '#002349',
    secondary: '#C29B40',
    header: '#002349',
    ring: '#002349',
    black: '#000000',
  },
  typography: baseTypography,
  spacing: baseSpacing,
  borderRadius: baseBorderRadius,
};

export const corcoranGroupTheme = {
  colors: {
    ...sharedColorCore,
    primary: '#1756ff',
    secondary: '#1b3c55',
    header: '#A3A3A3',
    ring: '#1756FF',
    black: '#000000',
  },
  typography: baseTypography,
  spacing: baseSpacing,
  borderRadius: baseBorderRadius,
};

export const compassTheme = {
  colors: {
    ...sharedColorCore,
    primary: '#000000',
    secondary: '#000000',
    header: '#000000',
    ring: '#000000',
    black: '#000000',
  },
  typography: baseTypography,
  spacing: baseSpacing,
  borderRadius: baseBorderRadius,
};